import { memo } from 'react';
import styled from '@emotion/styled';
import { ChatMarkdown } from '../Markdown/Markdown';

export type BlockQuoteProps = {
  className?: string;
  children?: React.ReactNode;
  value?: string;
};

export const BlockQuote = memo(({ className, children, value }: BlockQuoteProps) => {
  return (
    <Root className={className}>{typeof value === 'string' ? <ChatMarkdown value={value} /> : children}</Root>
  );
});

const Root = styled.blockquote(({ theme }) => ({
  margin: 0,
  padding: 15,
  boxSizing: 'border-box',
  width: '100%',

  whiteSpace: 'normal',

  backgroundColor: '#f9f9f9',

  borderRadius: 2,
  borderLeftStyle: 'solid',
  borderLeftWidth: 5,
  borderLeftColor: theme.palette.primary.main,
}));
